import React, { Component } from 'react';
import moment from 'moment';

const defaultContext = {
  language: 'en',
};

const LocalizeContext = React.createContext(defaultContext);

class LocalizeContextProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: defaultContext.language,
    };
    this.handleSetLanguage = this.handleSetLanguage.bind(this);
  }

  componentDidMount() {
    if (window.Localize) {
      this.changeLanguage(window.Localize.getLanguage());
      window.Localize.on('setLanguage', this.handleSetLanguage);
    }
  }

  componentWillUnmount() {
    if (window.Localize) {
      window.Localize.off('setLanguage', this.handleSetLanguage);
    }
  }

  handleSetLanguage(options) {
    const language = options.to.replace(/-.+/, '');
    this.changeLanguage(language);
  }

  changeLanguage(language) {
    moment.locale(language);

    this.setState({
      language,
    });
  }

  render() {
    const { language } = this.state;
    return (
      <LocalizeContext.Provider value={{ language }}>
        {this.props.children}
      </LocalizeContext.Provider>
    );
  }
}

export default {
  Provider: LocalizeContextProvider,
  Consumer: LocalizeContext.Consumer,
  defaultContext,
};
